import { Axes as e, Grid as a, renderGridLinesToCanvas as i, renderAxesToCanvas as t } from "@nivo/axes";
import { useAnnotations as n, Annotation as r, useComputedAnnotations as l, renderAnnotationsToCanvas as o } from "@nivo/annotations";
import { jsx as d, Fragment as u, jsxs as c } from "react/jsx-runtime";
import { BoxLegendSvg as s, renderLegendToCanvas as h } from "@nivo/legends";
import { useTheme as b, getPropertyAccessor as g, usePropertyAccessor as v, useValueFormatter as f, Container as m, useMotionConfig as p, useDimensions as x, bindDefs as y, CartesianMarkers as S, SvgWrapper as k, getRelativeCursor as w, isCursorInRect as L, ResponsiveWrapper as C } from "@nivo/core";
import { useMemo as V, createElement as W, useCallback as B, useState as M, Fragment as I, forwardRef as T, useRef as R, useEffect as P } from "react";
import { animated as H, to as E, useTransition as F } from "@react-spring/web";
import { useTooltip as X, BasicTooltip as Y } from "@nivo/tooltip";
import { useOrdinalColorScale as D, useInheritedColor as O } from "@nivo/colors";
import { computeScale as G } from "@nivo/scales";
import { stack as A, stackOffsetDiverging as j } from "d3-shape";
import q from "lodash/uniqBy";

function z() {
  return z = Object.assign || function (e) {
    for (var a = 1; a < arguments.length; a++) {
      var i = arguments[a];

      for (var t in i) {
        Object.prototype.hasOwnProperty.call(i, t) && (e[t] = i[t]);
      }
    }

    return e;
  }, z.apply(this, arguments);
}

function K(e, a) {
  if (null == e) return {};
  var i,
      t,
      n = {},
      r = Object.keys(e);

  for (t = 0; t < r.length; t++) {
    i = r[t], a.indexOf(i) >= 0 || (n[i] = e[i]);
  }

  return n;
}

var N,
    J = function J(e) {
  var a = e.bars,
      i = e.annotations,
      t = n({
    data: a,
    annotations: i,
    getPosition: function getPosition(e) {
      return {
        x: e.x + e.width / 2,
        y: e.y + e.height / 2
      };
    },
    getDimensions: function getDimensions(e) {
      var a = e.height,
          i = e.width;
      return {
        width: i,
        height: a,
        size: Math.max(i, a)
      };
    }
  });
  return d(u, {
    children: t.map(function (e, a) {
      return d(r, z({}, e), a);
    })
  });
},
    Q = function Q(e) {
  var a = e.width,
      i = e.height,
      t = e.legends,
      n = e.toggleSerie;
  return d(u, {
    children: t.map(function (e, t) {
      var r,
          l = e[0],
          o = e[1];
      return d(s, z({}, l, {
        containerWidth: a,
        containerHeight: i,
        data: null != (r = l.data) ? r : o,
        toggleSerie: l.toggleSerie && "keys" === l.dataFrom ? n : void 0
      }), t);
    })
  });
},
    U = ["data"],
    Z = function Z(e) {
  var a,
      i = e.bar,
      t = i.data,
      n = K(i, U),
      r = e.style,
      l = r.borderColor,
      o = r.color,
      u = r.height,
      s = r.labelColor,
      h = r.labelOpacity,
      g = r.labelX,
      v = r.labelY,
      f = r.transform,
      m = r.width,
      p = e.borderRadius,
      x = e.borderWidth,
      y = e.label,
      S = e.shouldRenderLabel,
      k = e.isInteractive,
      w = e.onClick,
      L = e.onMouseEnter,
      C = e.onMouseLeave,
      M = e.tooltip,
      I = e.isFocusable,
      T = e.ariaLabel,
      R = e.ariaLabelledBy,
      P = e.ariaDescribedBy,
      F = b(),
      Y = X(),
      D = Y.showTooltipFromEvent,
      O = Y.showTooltipAt,
      G = Y.hideTooltip,
      A = V(function () {
    return function () {
      return W(M, z({}, n, t));
    };
  }, [M, n, t]),
      j = B(function (e) {
    null == w || w(z({
      color: n.color
    }, t), e);
  }, [n, t, w]),
      q = B(function (e) {
    return D(A(), e);
  }, [D, A]),
      N = B(function (e) {
    null == L || L(t, e), D(A(), e);
  }, [t, L, D, A]),
      J = B(function (e) {
    null == C || C(t, e), G();
  }, [t, G, C]),
      Q = B(function () {
    O(A(), [n.absX + n.width / 2, n.absY]);
  }, [O, A, n]),
      Z = B(function () {
    G();
  }, [G]);
  return c(H.g, {
    transform: f,
    children: [d(H.rect, {
      width: E(m, function (e) {
        return Math.max(e, 0);
      }),
      height: E(u, function (e) {
        return Math.max(e, 0);
      }),
      rx: p,
      ry: p,
      fill: null != (a = t.fill) ? a : o,
      strokeWidth: x,
      stroke: l,
      focusable: I,
      tabIndex: I ? 0 : void 0,
      "aria-label": T ? T(t) : void 0,
      "aria-labelledby": R ? R(t) : void 0,
      "aria-describedby": P ? P(t) : void 0,
      onMouseEnter: k ? N : void 0,
      onMouseMove: k ? q : void 0,
      onMouseLeave: k ? J : void 0,
      onClick: k ? j : void 0,
      onFocus: k && I ? Q : void 0,
      onBlur: k && I ? Z : void 0
    }), S && d(H.text, {
      x: g,
      y: v,
      textAnchor: "middle",
      dominantBaseline: "central",
      fillOpacity: h,
      style: z({}, F.labels.text, {
        pointerEvents: "none",
        fill: s
      }),
      children: y
    })]
  });
},
    $ = ["color", "label"],
    _ = {
  indexBy: "id",
  keys: ["value"],
  groupMode: "stacked",
  layout: "vertical",
  reverse: !1,
  minValue: "auto",
  maxValue: "auto",
  valueScale: {
    type: "linear"
  },
  indexScale: {
    type: "band",
    round: !0
  },
  padding: .1,
  innerPadding: 0,
  axisBottom: {},
  axisLeft: {},
  enableGridX: !1,
  enableGridY: !0,
  enableLabel: !0,
  label: "formattedValue",
  labelSkipWidth: 0,
  labelSkipHeight: 0,
  labelTextColor: {
    from: "theme",
    theme: "labels.text.fill"
  },
  colorBy: "id",
  colors: {
    scheme: "nivo"
  },
  borderRadius: 0,
  borderWidth: 0,
  borderColor: {
    from: "color"
  },
  isInteractive: !0,
  tooltip: function tooltip(e) {
    var a = e.color,
        i = e.label,
        t = K(e, $);
    return d(Y, {
      id: i,
      value: t.formattedValue,
      enableChip: !0,
      color: a
    });
  },
  tooltipLabel: function tooltipLabel(e) {
    return e.id + " - " + e.indexValue;
  },
  legends: [],
  initialHiddenIds: [],
  annotations: [],
  markers: []
},
    ee = z({}, _, {
  layers: ["grid", "axes", "bars", "markers", "legends", "annotations"],
  barComponent: Z,
  defs: [],
  fill: [],
  animate: !0,
  motionConfig: "default",
  role: "img",
  isFocusable: !1
}),
    ae = z({}, _, {
  layers: ["grid", "axes", "bars", "legends", "annotations"],
  pixelRatio: "undefined" != typeof window && null != (N = window.devicePixelRatio) ? N : 1
}),
    ie = function ie(e, a, i, t, n, r) {
  return G(t, {
    all: e.map(a),
    min: 0,
    max: 0
  }, n, r).padding(i);
},
    te = function te(e, a) {
  return e.map(function (e) {
    return z({}, a.reduce(function (e, a) {
      return e[a] = null, e;
    }, {}), e);
  });
},
    ne = function ne(e) {
  return Object.keys(e).reduce(function (a, i) {
    return e[i] && (a[i] = e[i]), a;
  }, {});
},
    re = function re(e) {
  return [e, Number(e)];
},
    le = ["layout", "minValue", "maxValue", "reverse", "width", "height", "padding", "innerPadding", "valueScale", "indexScale", "hiddenIds"],
    oe = function oe(e, a) {
  return e > a;
},
    de = function de(e, a) {
  return e < a;
},
    ue = function ue(e, a) {
  return Array.from(" ".repeat(a - e), function (a, i) {
    return e + i;
  });
},
    ce = function ce(e) {
  return oe(e, 0) ? 0 : e;
},
    se = function se(e, a, i, t) {
  var n = e.data,
      r = e.formatValue,
      l = e.getColor,
      o = e.getIndex,
      d = e.getTooltipLabel,
      u = e.innerPadding,
      c = void 0 === u ? 0 : u,
      s = e.keys,
      h = e.xScale,
      b = e.yScale,
      g = e.margin,
      v = i ? de : oe,
      f = n.map(ne),
      m = [];
  return s.forEach(function (e, i) {
    return ue(0, h.domain().length).forEach(function (u) {
      var s,
          p,
          x,
          y = re(n[u][e]),
          S = y[0],
          k = y[1],
          w = o(n[u]),
          L = (null != (s = h(w)) ? s : 0) + a * i + c * i,
          C = v(p = k, 0) ? null != (x = b(p)) ? x : 0 : t,
          V = function (e, a) {
        var i;
        return v(e, 0) ? t - a : (null != (i = b(e)) ? i : 0) - t;
      }(k, C),
          W = {
        id: e,
        value: null === S ? S : k,
        formattedValue: r(k),
        hidden: !1,
        index: u,
        indexValue: w,
        data: f[u]
      };

      m.push({
        key: e + "." + W.indexValue,
        index: m.length,
        data: W,
        x: L,
        y: C,
        absX: g.left + L,
        absY: g.top + C,
        width: a,
        height: V,
        color: l(W),
        label: d(W)
      });
    });
  }), m;
},
    he = function he(e, a, i, t) {
  var n = e.data,
      r = e.formatValue,
      l = e.getIndex,
      o = e.getColor,
      d = e.getTooltipLabel,
      u = e.keys,
      c = e.innerPadding,
      s = void 0 === c ? 0 : c,
      h = e.xScale,
      b = e.yScale,
      g = e.margin,
      v = i ? de : oe,
      f = n.map(ne),
      m = [];
  return u.forEach(function (e, i) {
    return ue(0, b.domain().length).forEach(function (u) {
      var c,
          p,
          x,
          y = re(n[u][e]),
          S = y[0],
          k = y[1],
          w = l(n[u]),
          L = v(p = k, 0) ? t : null != (x = h(p)) ? x : 0,
          C = (null != (c = b(w)) ? c : 0) + a * i + s * i,
          V = function (e, a) {
        var i;
        return v(e, 0) ? (null != (i = h(e)) ? i : 0) - t : t - a;
      }(k, L),
          W = {
        id: e,
        value: null === S ? S : k,
        formattedValue: r(k),
        hidden: !1,
        index: u,
        indexValue: w,
        data: f[u]
      };

      m.push({
        key: e + "." + W.indexValue,
        index: m.length,
        data: W,
        x: L,
        y: C,
        absX: g.left + L,
        absY: g.top + C,
        width: V,
        height: a,
        color: o(W),
        label: d(W)
      });
    });
  }), m;
},
    be = function be(e) {
  var a,
      i,
      t = e.layout,
      n = e.minValue,
      r = e.maxValue,
      l = e.reverse,
      o = e.width,
      d = e.height,
      u = e.padding,
      c = void 0 === u ? 0 : u,
      s = e.innerPadding,
      h = void 0 === s ? 0 : s,
      b = e.valueScale,
      g = e.indexScale,
      v = e.hiddenIds,
      f = void 0 === v ? [] : v,
      m = K(e, le),
      p = m.keys.filter(function (e) {
    return !f.includes(e);
  }),
      x = te(m.data, p),
      y = "vertical" === t ? ["y", "x", o] : ["x", "y", d],
      S = y[0],
      k = y[1],
      w = y[2],
      L = ie(x, m.getIndex, c, g, w, k),
      C = z({
    max: r,
    min: n,
    reverse: l
  }, b),
      V = "auto" === C.min ? ce : function (e) {
    return e;
  },
      W = x.reduce(function (e, a) {
    return [].concat(e, p.map(function (e) {
      return a[e];
    }));
  }, []).filter(Boolean),
      B = V(Math.min.apply(Math, W)),
      M = (i = Math.max.apply(Math, W), isFinite(i) ? i : 0),
      I = G(C, {
    all: W,
    min: B,
    max: M
  }, "x" === S ? o : d, S),
      T = "vertical" === t ? [L, I] : [I, L],
      R = T[0],
      P = T[1],
      H = (L.bandwidth() - h * (p.length - 1)) / p.length,
      E = [z({}, m, {
    data: x,
    keys: p,
    innerPadding: h,
    xScale: R,
    yScale: P
  }), H, C.reverse, null != (a = I(0)) ? a : 0];
  return {
    xScale: R,
    yScale: P,
    bars: H > 0 ? "vertical" === t ? se.apply(void 0, E) : he.apply(void 0, E) : []
  };
},
    ge = ["data", "layout", "minValue", "maxValue", "reverse", "width", "height", "padding", "valueScale", "indexScale", "hiddenIds"],
    ve = function e(a) {
  var i;
  return a.some(Array.isArray) ? e((i = []).concat.apply(i, a)) : a;
},
    fe = function fe(e, a, i) {
  var t = e.formatValue,
      n = e.getColor,
      r = e.getIndex,
      l = e.getTooltipLabel,
      o = e.innerPadding,
      d = e.stackedData,
      u = e.xScale,
      c = e.yScale,
      s = e.margin,
      h = [];
  return d.forEach(function (e) {
    return u.domain().forEach(function (d, b) {
      var g,
          v,
          f = e[b],
          m = null != (g = u(r(f.data))) ? g : 0,
          p = (null != (v = function (e) {
        return c(e[i ? 0 : 1]);
      }(f)) ? v : 0) + .5 * o,
          x = function (e, a) {
        var t;
        return (null != (t = c(e[i ? 1 : 0])) ? t : 0) - a;
      }(f, p) - o,
          y = re(f.data[e.key]),
          S = y[0],
          k = y[1],
          w = {
        id: e.key,
        value: null === S ? S : k,
        formattedValue: t(k),
        hidden: !1,
        index: b,
        indexValue: d,
        data: ne(f.data)
      };

      h.push({
        key: e.key + "." + d,
        index: h.length,
        data: w,
        x: m,
        y: p,
        absX: s.left + m,
        absY: s.top + p,
        width: a,
        height: x,
        color: n(w),
        label: l(w)
      });
    });
  }), h;
},
    me = function me(e, a, i) {
  var t = e.formatValue,
      n = e.getColor,
      r = e.getIndex,
      l = e.getTooltipLabel,
      o = e.innerPadding,
      d = e.stackedData,
      u = e.xScale,
      c = e.yScale,
      s = e.margin,
      h = [];
  return d.forEach(function (e) {
    return c.domain().forEach(function (d, b) {
      var g,
          v,
          f = e[b],
          m = null != (g = c(r(f.data))) ? g : 0,
          p = (null != (v = function (e) {
        return u(e[i ? 1 : 0]);
      }(f)) ? v : 0) + .5 * o,
          x = function (e, a) {
        var t;
        return (null != (t = u(e[i ? 0 : 1])) ? t : 0) - a;
      }(f, p) - o,
          y = re(f.data[e.key]),
          S = y[0],
          k = y[1],
          w = {
        id: e.key,
        value: null === S ? S : k,
        formattedValue: t(k),
        hidden: !1,
        index: b,
        indexValue: d,
        data: ne(f.data)
      };

      h.push({
        key: e.key + "." + d,
        index: h.length,
        data: w,
        x: p,
        y: m,
        absX: s.left + p,
        absY: s.top + m,
        width: x,
        height: a,
        color: n(w),
        label: l(w)
      });
    });
  }), h;
},
    pe = function pe(e) {
  var a,
      i = e.data,
      t = e.layout,
      n = e.minValue,
      r = e.maxValue,
      l = e.reverse,
      o = e.width,
      d = e.height,
      u = e.padding,
      c = void 0 === u ? 0 : u,
      s = e.valueScale,
      h = e.indexScale,
      b = e.hiddenIds,
      g = void 0 === b ? [] : b,
      v = K(e, ge),
      f = v.keys.filter(function (e) {
    return !g.includes(e);
  }),
      m = A().keys(f).offset(j)(te(i, f)),
      p = "vertical" === t ? ["y", "x", o] : ["x", "y", d],
      x = p[0],
      y = p[1],
      S = p[2],
      k = ie(i, v.getIndex, c, h, S, y),
      w = z({
    max: r,
    min: n,
    reverse: l
  }, s),
      L = (a = ve(m), "log" === s.type ? a.filter(function (e) {
    return 0 !== e;
  }) : a),
      C = Math.min.apply(Math, L),
      V = Math.max.apply(Math, L),
      W = G(w, {
    all: L,
    min: C,
    max: V
  }, "x" === x ? o : d, x),
      B = "vertical" === t ? [k, W] : [W, k],
      M = B[0],
      I = B[1],
      T = v.innerPadding > 0 ? v.innerPadding : 0,
      R = k.bandwidth(),
      P = [z({}, v, {
    innerPadding: T,
    stackedData: m,
    xScale: M,
    yScale: I
  }), R, w.reverse];
  return {
    xScale: M,
    yScale: I,
    bars: R > 0 ? "vertical" === t ? fe.apply(void 0, P) : me.apply(void 0, P) : []
  };
},
    xe = function xe(e) {
  var a = e.bars,
      i = e.direction,
      t = e.from,
      n = e.groupMode,
      r = e.layout,
      l = e.legendLabel,
      o = e.reverse,
      d = g(null != l ? l : "indexes" === t ? "indexValue" : "id");
  return "indexes" === t ? function (e, a, i) {
    var t = q(e.map(function (e) {
      var a, t;
      return {
        id: null != (a = e.data.indexValue) ? a : "",
        label: i(e.data),
        hidden: e.data.hidden,
        color: null != (t = e.color) ? t : "#000"
      };
    }), function (e) {
      return e.id;
    });
    return "horizontal" === a && t.reverse(), t;
  }(a, r, d) : function (e, a, i, t, n, r) {
    var l = q(e.map(function (e) {
      var a;
      return {
        id: e.data.id,
        label: r(e.data),
        hidden: e.data.hidden,
        color: null != (a = e.color) ? a : "#000"
      };
    }), function (e) {
      return e.id;
    });
    return ("vertical" === a && "stacked" === t && "column" === i && !0 !== n || "horizontal" === a && "stacked" === t && !0 === n) && l.reverse(), l;
  }(a, r, i, n, o, d);
},
    ye = function ye(e) {
  var a = e.indexBy,
      i = void 0 === a ? _.indexBy : a,
      t = e.keys,
      n = void 0 === t ? _.keys : t,
      r = e.label,
      l = void 0 === r ? _.label : r,
      o = e.tooltipLabel,
      d = void 0 === o ? _.tooltipLabel : o,
      u = e.valueFormat,
      c = e.colors,
      s = void 0 === c ? _.colors : c,
      h = e.colorBy,
      g = void 0 === h ? _.colorBy : h,
      m = e.borderColor,
      p = void 0 === m ? _.borderColor : m,
      x = e.labelTextColor,
      y = void 0 === x ? _.labelTextColor : x,
      S = e.groupMode,
      k = void 0 === S ? _.groupMode : S,
      w = e.layout,
      L = void 0 === w ? _.layout : w,
      C = e.reverse,
      W = void 0 === C ? _.reverse : C,
      I = e.data,
      T = e.minValue,
      R = void 0 === T ? _.minValue : T,
      P = e.maxValue,
      H = void 0 === P ? _.maxValue : P,
      E = e.margin,
      F = e.width,
      X = e.height,
      Y = e.padding,
      G = void 0 === Y ? _.padding : Y,
      A = e.innerPadding,
      j = void 0 === A ? _.innerPadding : A,
      q = e.valueScale,
      K = void 0 === q ? _.valueScale : q,
      N = e.indexScale,
      J = void 0 === N ? _.indexScale : N,
      Q = e.initialHiddenIds,
      U = void 0 === Q ? _.initialHiddenIds : Q,
      Z = e.enableLabel,
      $ = void 0 === Z ? _.enableLabel : Z,
      ee = e.labelSkipWidth,
      ae = void 0 === ee ? _.labelSkipWidth : ee,
      ie = e.labelSkipHeight,
      te = void 0 === ie ? _.labelSkipHeight : ie,
      ne = e.legends,
      re = void 0 === ne ? _.legends : ne,
      le = e.legendLabel,
      oe = M(null != U ? U : []),
      de = oe[0],
      ue = oe[1],
      ce = B(function (e) {
    ue(function (a) {
      return a.indexOf(e) > -1 ? a.filter(function (a) {
        return a !== e;
      }) : [].concat(a, [e]);
    });
  }, []),
      se = v(i),
      he = v(l),
      ge = v(d),
      ve = f(u),
      fe = b(),
      me = D(s, g),
      ye = O(p, fe),
      Se = O(y, fe),
      ke = ("grouped" === k ? be : pe)({
    layout: L,
    reverse: W,
    data: I,
    getIndex: se,
    keys: n,
    minValue: R,
    maxValue: H,
    width: F,
    height: X,
    getColor: me,
    padding: G,
    innerPadding: j,
    valueScale: K,
    indexScale: J,
    hiddenIds: de,
    formatValue: ve,
    getTooltipLabel: ge,
    margin: E
  }),
      we = ke.bars,
      Le = ke.xScale,
      Ce = ke.yScale,
      Ve = V(function () {
    return we.filter(function (e) {
      return null !== e.data.value;
    }).map(function (e, a) {
      return z({}, e, {
        index: a
      });
    });
  }, [we]),
      We = B(function (e) {
    var a = e.width,
        i = e.height;
    return !!$ && !(ae > 0 && a < ae) && !(te > 0 && i < te);
  }, [$, ae, te]),
      Be = V(function () {
    return n.map(function (e) {
      var a = we.find(function (a) {
        return a.data.id === e;
      });
      return z({}, a, {
        data: z({
          id: e
        }, null == a ? void 0 : a.data, {
          hidden: de.includes(e)
        })
      });
    });
  }, [de, n, we]),
      Me = V(function () {
    return re.map(function (e) {
      return [e, xe({
        bars: "keys" === e.dataFrom ? Be : we,
        direction: e.direction,
        from: e.dataFrom,
        groupMode: k,
        layout: L,
        legendLabel: le,
        reverse: W
      })];
    });
  }, [re, Be, we, k, L, le, W]);
  return {
    bars: we,
    barsWithValue: Ve,
    xScale: Le,
    yScale: Ce,
    getIndex: se,
    getLabel: he,
    getTooltipLabel: ge,
    formatValue: ve,
    getColor: me,
    getBorderColor: ye,
    getLabelColor: Se,
    shouldRenderBarLabel: We,
    hiddenIds: de,
    toggleSerie: ce,
    legendsWithData: Me
  };
},
    Se = ["isInteractive", "animate", "motionConfig", "theme", "renderWrapper"],
    ke = function ke(i) {
  var t = i.data,
      n = i.indexBy,
      r = i.keys,
      l = i.margin,
      o = i.width,
      u = i.height,
      c = i.groupMode,
      s = i.layout,
      h = i.reverse,
      b = i.minValue,
      g = i.maxValue,
      v = i.valueScale,
      f = i.indexScale,
      m = i.padding,
      w = i.innerPadding,
      L = i.axisTop,
      C = i.axisRight,
      B = i.axisBottom,
      M = void 0 === B ? ee.axisBottom : B,
      T = i.axisLeft,
      R = void 0 === T ? ee.axisLeft : T,
      P = i.enableGridX,
      H = void 0 === P ? ee.enableGridX : P,
      E = i.enableGridY,
      X = void 0 === E ? ee.enableGridY : E,
      Y = i.gridXValues,
      D = i.gridYValues,
      O = i.layers,
      G = void 0 === O ? ee.layers : O,
      A = i.barComponent,
      j = void 0 === A ? ee.barComponent : A,
      q = i.enableLabel,
      K = i.label,
      N = i.labelSkipWidth,
      U = i.labelSkipHeight,
      Z = i.labelTextColor,
      $ = i.markers,
      _ = void 0 === $ ? ee.markers : $,
      ae = i.colorBy,
      ie = i.colors,
      te = i.defs,
      ne = void 0 === te ? ee.defs : te,
      re = i.fill,
      le = void 0 === re ? ee.fill : re,
      oe = i.borderRadius,
      de = void 0 === oe ? ee.borderRadius : oe,
      ue = i.borderWidth,
      ce = void 0 === ue ? ee.borderWidth : ue,
      se = i.borderColor,
      he = i.annotations,
      be = void 0 === he ? ee.annotations : he,
      ge = i.legendLabel,
      ve = i.tooltipLabel,
      fe = i.valueFormat,
      me = i.isInteractive,
      pe = void 0 === me ? ee.isInteractive : me,
      xe = i.tooltip,
      Se = void 0 === xe ? ee.tooltip : xe,
      ke = i.onClick,
      we = i.onMouseEnter,
      Le = i.onMouseLeave,
      Ce = i.legends,
      Ve = i.role,
      We = void 0 === Ve ? ee.role : Ve,
      Be = i.ariaLabel,
      Me = i.ariaLabelledBy,
      Ie = i.ariaDescribedBy,
      Te = i.isFocusable,
      Re = void 0 === Te ? ee.isFocusable : Te,
      Pe = i.barAriaLabel,
      He = i.barAriaLabelledBy,
      Ee = i.barAriaDescribedBy,
      Fe = i.initialHiddenIds,
      Xe = p(),
      Ye = Xe.animate,
      De = Xe.config,
      Oe = x(o, u, l),
      Ge = Oe.outerWidth,
      Ae = Oe.outerHeight,
      je = Oe.margin,
      qe = Oe.innerWidth,
      ze = Oe.innerHeight,
      Ke = ye({
    indexBy: n,
    label: K,
    tooltipLabel: ve,
    valueFormat: fe,
    colors: ie,
    colorBy: ae,
    borderColor: se,
    labelTextColor: Z,
    groupMode: c,
    layout: s,
    reverse: h,
    data: t,
    keys: r,
    minValue: b,
    maxValue: g,
    margin: je,
    width: qe,
    height: ze,
    padding: m,
    innerPadding: w,
    valueScale: v,
    indexScale: f,
    enableLabel: q,
    labelSkipWidth: N,
    labelSkipHeight: U,
    legends: Ce,
    legendLabel: ge,
    initialHiddenIds: Fe
  }),
      Ne = Ke.bars,
      Je = Ke.barsWithValue,
      Qe = Ke.xScale,
      Ue = Ke.yScale,
      Ze = Ke.getLabel,
      $e = Ke.getTooltipLabel,
      _e = Ke.getBorderColor,
      ea = Ke.getLabelColor,
      aa = Ke.shouldRenderBarLabel,
      ia = Ke.toggleSerie,
      ta = Ke.legendsWithData,
      na = F(Je, {
    keys: function keys(e) {
      return e.key;
    },
    from: function from(e) {
      return z({
        borderColor: _e(e),
        color: e.color,
        height: 0,
        labelColor: ea(e),
        labelOpacity: 0,
        labelX: e.width / 2,
        labelY: e.height / 2,
        transform: "translate(" + e.x + ", " + (e.y + e.height) + ")",
        width: e.width
      }, "vertical" === s ? {} : {
        height: e.height,
        transform: "translate(" + e.x + ", " + e.y + ")",
        width: 0
      });
    },
    enter: function enter(e) {
      return {
        borderColor: _e(e),
        color: e.color,
        height: e.height,
        labelColor: ea(e),
        labelOpacity: 1,
        labelX: e.width / 2,
        labelY: e.height / 2,
        transform: "translate(" + e.x + ", " + e.y + ")",
        width: e.width
      };
    },
    update: function update(e) {
      return {
        borderColor: _e(e),
        color: e.color,
        height: e.height,
        labelColor: ea(e),
        labelOpacity: 1,
        labelX: e.width / 2,
        labelY: e.height / 2,
        transform: "translate(" + e.x + ", " + e.y + ")",
        width: e.width
      };
    },
    leave: function leave(e) {
      return z({
        borderColor: _e(e),
        color: e.color,
        height: 0,
        labelColor: ea(e),
        labelOpacity: 0,
        labelX: e.width / 2,
        labelY: 0,
        transform: "translate(" + e.x + ", " + (e.y + e.height) + ")",
        width: e.width
      }, "vertical" === s ? {} : {
        labelX: 0,
        labelY: e.height / 2,
        height: e.height,
        transform: "translate(" + e.x + ", " + e.y + ")",
        width: 0
      });
    },
    config: De,
    immediate: !Ye
  }),
      ra = V(function () {
    return {
      borderRadius: de,
      borderWidth: ce,
      enableLabel: q,
      isInteractive: pe,
      labelSkipWidth: N,
      labelSkipHeight: U,
      onClick: ke,
      onMouseEnter: we,
      onMouseLeave: Le,
      getTooltipLabel: $e,
      tooltip: Se,
      isFocusable: Re,
      ariaLabel: Pe,
      ariaLabelledBy: He,
      ariaDescribedBy: Ee
    };
  }, [de, ce, q, $e, pe, U, N, ke, we, Le, Se, Re, Pe, He, Ee]),
      la = y(ne, Ne, le, {
    dataKey: "data",
    targetKey: "data.fill"
  }),
      oa = {
    annotations: null,
    axes: null,
    bars: null,
    grid: null,
    legends: null,
    markers: null
  };

  G.includes("annotations") && (oa.annotations = d(J, {
    bars: Ne,
    annotations: be
  }, "annotations")), G.includes("axes") && (oa.axes = d(e, {
    xScale: Qe,
    yScale: Ue,
    width: qe,
    height: ze,
    top: L,
    right: C,
    bottom: M,
    left: R
  }, "axes")), G.includes("bars") && (oa.bars = d(I, {
    children: na(function (e, a) {
      return W(j, z({}, ra, {
        bar: a,
        style: e,
        shouldRenderLabel: aa(a),
        label: Ze(a.data)
      }));
    })
  }, "bars")), G.includes("grid") && (oa.grid = d(a, {
    width: qe,
    height: ze,
    xScale: H ? Qe : null,
    yScale: X ? Ue : null,
    xValues: Y,
    yValues: D
  }, "grid")), G.includes("legends") && (oa.legends = d(Q, {
    width: qe,
    height: ze,
    legends: ta,
    toggleSerie: ia
  }, "legends")), G.includes("markers") && (oa.markers = d(S, {
    markers: _,
    width: qe,
    height: ze,
    xScale: Qe,
    yScale: Ue
  }, "markers"));
  var da = V(function () {
    return z({}, ra, {
      margin: je,
      innerWidth: qe,
      innerHeight: ze,
      width: o,
      height: u,
      bars: Ne,
      xScale: Qe,
      yScale: Ue
    });
  }, [ra, je, qe, ze, o, u, Ne, Qe, Ue]);
  return d(k, {
    width: Ge,
    height: Ae,
    margin: je,
    defs: la,
    role: We,
    ariaLabel: Be,
    ariaLabelledBy: Me,
    ariaDescribedBy: Ie,
    isFocusable: Re,
    children: G.map(function (e, a) {
      var i;
      return "function" == typeof e ? d(I, {
        children: W(e, da)
      }, a) : null != (i = null == oa ? void 0 : oa[e]) ? i : null;
    })
  });
},
    we = function we(e) {
  var a = e.isInteractive,
      i = void 0 === a ? ee.isInteractive : a,
      t = e.animate,
      n = void 0 === t ? ee.animate : t,
      r = e.motionConfig,
      l = void 0 === r ? ee.motionConfig : r,
      o = e.theme,
      u = e.renderWrapper,
      c = K(e, Se);
  return d(m, {
    animate: n,
    isInteractive: i,
    motionConfig: l,
    renderWrapper: u,
    theme: o,
    children: d(ke, z({
      isInteractive: i
    }, c))
  });
},
    Le = ["isInteractive", "renderWrapper", "theme"],
    Ce = function Ce(e, a, i, t) {
  return e.find(function (e) {
    return L(e.x + a.left, e.y + a.top, e.width, e.height, i, t);
  });
},
    Ve = function Ve(e) {
  var a = e.data,
      r = e.indexBy,
      u = e.keys,
      c = e.margin,
      s = e.width,
      g = e.height,
      v = e.groupMode,
      f = e.layout,
      m = e.reverse,
      p = e.minValue,
      y = e.maxValue,
      S = e.valueScale,
      k = e.indexScale,
      L = e.padding,
      C = e.innerPadding,
      M = e.axisTop,
      I = e.axisRight,
      T = e.axisBottom,
      H = void 0 === T ? ae.axisBottom : T,
      E = e.axisLeft,
      F = void 0 === E ? ae.axisLeft : E,
      Y = e.enableGridX,
      D = void 0 === Y ? ae.enableGridX : Y,
      O = e.enableGridY,
      G = void 0 === O ? ae.enableGridY : O,
      A = e.gridXValues,
      j = e.gridYValues,
      q = e.layers,
      K = void 0 === q ? ae.layers : q,
      N = e.renderBar,
      J = void 0 === N ? function (e, a) {
    var i = a.bar,
        t = i.color,
        n = i.height,
        r = i.width,
        l = i.x,
        o = i.y,
        d = a.borderColor,
        u = a.borderRadius,
        c = a.borderWidth,
        s = a.label,
        h = a.labelColor,
        b = a.shouldRenderLabel;

    if (e.fillStyle = t, c > 0 && (e.strokeStyle = d, e.lineWidth = c), e.beginPath(), u > 0) {
      var g = Math.min(u, n);
      e.moveTo(l + g, o), e.lineTo(l + r - g, o), e.quadraticCurveTo(l + r, o, l + r, o + g), e.lineTo(l + r, o + n - g), e.quadraticCurveTo(l + r, o + n, l + r - g, o + n), e.lineTo(l + g, o + n), e.quadraticCurveTo(l, o + n, l, o + n - g), e.lineTo(l, o + g), e.quadraticCurveTo(l, o, l + g, o), e.closePath();
    } else e.rect(l, o, r, n);

    e.fill(), c > 0 && e.stroke(), b && (e.textBaseline = "middle", e.textAlign = "center", e.fillStyle = h, e.fillText(s, l + r / 2, o + n / 2));
  } : N,
      Q = e.enableLabel,
      U = e.label,
      Z = e.labelSkipWidth,
      $ = e.labelSkipHeight,
      _ = e.labelTextColor,
      ee = e.colorBy,
      ie = e.colors,
      te = e.borderRadius,
      ne = void 0 === te ? ae.borderRadius : te,
      re = e.borderWidth,
      le = void 0 === re ? ae.borderWidth : re,
      oe = e.borderColor,
      de = e.annotations,
      ue = void 0 === de ? ae.annotations : de,
      ce = e.legendLabel,
      se = e.tooltipLabel,
      he = e.valueFormat,
      be = e.isInteractive,
      ge = void 0 === be ? ae.isInteractive : be,
      ve = e.tooltip,
      fe = void 0 === ve ? ae.tooltip : ve,
      me = e.onClick,
      pe = e.onMouseEnter,
      xe = e.onMouseLeave,
      Se = e.legends,
      ke = e.pixelRatio,
      we = void 0 === ke ? ae.pixelRatio : ke,
      Le = e.canvasRef,
      Ve = R(null),
      We = b(),
      Be = x(s, g, c),
      Me = Be.margin,
      Ie = Be.innerWidth,
      Te = Be.innerHeight,
      Re = Be.outerWidth,
      Pe = Be.outerHeight,
      He = ye({
    indexBy: r,
    label: U,
    tooltipLabel: se,
    valueFormat: he,
    colors: ie,
    colorBy: ee,
    borderColor: oe,
    labelTextColor: _,
    groupMode: v,
    layout: f,
    reverse: m,
    data: a,
    keys: u,
    minValue: p,
    maxValue: y,
    margin: Me,
    width: Ie,
    height: Te,
    padding: L,
    innerPadding: C,
    valueScale: S,
    indexScale: k,
    enableLabel: Q,
    labelSkipWidth: Z,
    labelSkipHeight: $,
    legends: Se,
    legendLabel: ce
  }),
      Ee = He.bars,
      Fe = He.barsWithValue,
      Xe = He.xScale,
      Ye = He.yScale,
      De = He.getLabel,
      Oe = He.getTooltipLabel,
      Ge = He.getBorderColor,
      Ae = He.getLabelColor,
      je = He.shouldRenderBarLabel,
      qe = He.legendsWithData,
      ze = X(),
      Ke = ze.showTooltipFromEvent,
      Ne = ze.hideTooltip,
      Je = l({
    annotations: n({
      data: Ee,
      annotations: ue,
      getPosition: function getPosition(e) {
        return {
          x: e.x,
          y: e.y
        };
      },
      getDimensions: function getDimensions(e) {
        var a = e.width,
            i = e.height;
        return {
          width: a,
          height: i,
          size: Math.max(a, i)
        };
      }
    })
  }),
      Qe = V(function () {
    return {
      borderRadius: ne,
      borderWidth: le,
      enableLabel: Q,
      isInteractive: ge,
      labelSkipWidth: Z,
      labelSkipHeight: $,
      onClick: me,
      onMouseEnter: pe,
      onMouseLeave: xe,
      getTooltipLabel: Oe,
      tooltip: fe,
      margin: Me,
      innerWidth: Ie,
      innerHeight: Te,
      width: s,
      height: g,
      bars: Ee,
      xScale: Xe,
      yScale: Ye
    };
  }, [ne, le, Q, Oe, g, Te, Ie, ge, $, Z, Me, me, pe, xe, Ee, Xe, Ye, fe, s]);
  P(function () {
    var e,
        a = null == (e = Ve.current) ? void 0 : e.getContext("2d");
    Ve.current && a && (Ve.current.width = Re * we, Ve.current.height = Pe * we, a.scale(we, we), a.fillStyle = We.background, a.fillRect(0, 0, Re, Pe), a.translate(Me.left, Me.top), K.forEach(function (e) {
      "grid" === e ? "number" == typeof We.grid.line.strokeWidth && We.grid.line.strokeWidth > 0 && (a.lineWidth = We.grid.line.strokeWidth, a.strokeStyle = We.grid.line.stroke, D && i(a, {
        width: s,
        height: g,
        scale: Xe,
        axis: "x",
        values: A
      }), G && i(a, {
        width: s,
        height: g,
        scale: Ye,
        axis: "y",
        values: j
      })) : "axes" === e ? t(a, {
        xScale: Xe,
        yScale: Ye,
        width: Ie,
        height: Te,
        top: M,
        right: I,
        bottom: H,
        left: F,
        theme: We
      }) : "bars" === e ? Fe.forEach(function (e) {
        J(a, {
          bar: e,
          borderColor: Ge(e),
          borderRadius: ne,
          borderWidth: le,
          label: De(e.data),
          labelColor: Ae(e),
          shouldRenderLabel: je(e)
        });
      }) : "legends" === e ? qe.forEach(function (e) {
        var i = e[0],
            t = e[1];
        h(a, z({}, i, {
          data: t,
          containerWidth: Ie,
          containerHeight: Te,
          theme: We
        }));
      }) : "annotations" === e ? o(a, {
        annotations: Je,
        theme: We
      }) : "function" == typeof e && e(a, Qe);
    }), a.save());
  }, [H, F, I, M, Fe, ne, le, Je, D, G, Ge, De, Ae, A, j, v, g, Te, Ie, Qe, K, f, qe, Me.left, Me.top, Pe, Re, we, J, Xe, Ye, m, je, We, s]);
  var Ue = B(function (e) {
    if (Ee && Ve.current) {
      var a = w(Ve.current, e),
          i = a[0],
          t = a[1],
          n = Ce(Ee, Me, i, t);
      void 0 !== n ? (Ke(W(fe, z({}, n.data, {
        color: n.color,
        label: n.label,
        value: Number(n.data.value)
      })), e), "mouseenter" === e.type && (null == pe || pe(n.data, e))) : Ne();
    }
  }, [Ne, Me, pe, Ee, Ke, fe]),
      Ze = B(function (e) {
    if (Ee && Ve.current) {
      Ne();
      var a = w(Ve.current, e),
          i = a[0],
          t = a[1],
          n = Ce(Ee, Me, i, t);
      n && (null == xe || xe(n.data, e));
    }
  }, [Ne, Me, xe, Ee]),
      $e = B(function (e) {
    if (Ee && Ve.current) {
      var a = w(Ve.current, e),
          i = a[0],
          t = a[1],
          n = Ce(Ee, Me, i, t);
      void 0 !== n && (null == me || me(z({}, n.data, {
        color: n.color
      }), e));
    }
  }, [Me, me, Ee]);
  return d("canvas", {
    ref: function ref(e) {
      Ve.current = e, Le && "current" in Le && (Le.current = e);
    },
    width: Re * we,
    height: Pe * we,
    style: {
      width: Re,
      height: Pe,
      cursor: ge ? "auto" : "normal"
    },
    onMouseEnter: ge ? Ue : void 0,
    onMouseMove: ge ? Ue : void 0,
    onMouseLeave: ge ? Ze : void 0,
    onClick: ge ? $e : void 0
  });
},
    We = T(function (e, a) {
  var i = e.isInteractive,
      t = e.renderWrapper,
      n = e.theme,
      r = K(e, Le);
  return d(m, {
    isInteractive: i,
    renderWrapper: t,
    theme: n,
    animate: !1,
    children: d(Ve, z({}, r, {
      canvasRef: a
    }))
  });
}),
    Be = function Be(e) {
  return d(C, {
    children: function children(a) {
      var i = a.width,
          t = a.height;
      return d(we, z({
        width: i,
        height: t
      }, e));
    }
  });
},
    Me = T(function (e, a) {
  return d(C, {
    children: function children(i) {
      var t = i.width,
          n = i.height;
      return d(We, z({
        width: t,
        height: n
      }, e, {
        ref: a
      }));
    }
  });
});

export { we as Bar, We as BarCanvas, Z as BarItem, Be as ResponsiveBar, Me as ResponsiveBarCanvas, ae as canvasDefaultProps, _ as defaultProps, ee as svgDefaultProps }; //# sourceMappingURL=nivo-bar.es.js.map